import { ServersList } from './sidePanel/servers/ServersList';

export const ServersSidePanel = () => <ServersList />;
